import React from 'react';
import PropTypes from 'prop-types';
import { ClockIcon } from '../../../model/icons';
import BetAccordion from './BetAccordion';
import BetRow from './BetRow';
import { formatDt, betsLabel, placeClass } from './betUtils';

// Карточка мероприятия (.bt-ev): название, коэффициенты команд, ставки, итоговые места.
export default function ActivityEventCard({ event, bets, colorOf, finished, onEdit, onFinish, onDelete }) {
    const { title, startTime, results, teamOdds } = event;
    const sortedResults = results ? [...results].sort((a, b) => a.place - b.place) : [];

    return (
        <div className={`bt-ev${finished ? ' done' : ''}`}>
            <div className="eh">
                <div className="etitle">{title}</div>
                <span className={`bt-badge ${finished ? 'done' : 'active'}`}>{finished ? 'Завершено' : 'Активно'}</span>
            </div>

            <div className="edt"><span className="ci"><ClockIcon /></span>{formatDt(startTime)}</div>

            {teamOdds && teamOdds.length > 0 && (
                <BetAccordion label={`Коэффициенты (${teamOdds.length} команд)`}>
                    <div className="bt-coeffs">
                        {teamOdds.map(team => (
                            <div key={team.teamId} className="bt-coeff">
                                <div className="ct">
                                    <div className="cn"><span className="bdot" style={{ background: colorOf(team.teamId) }} />{team.teamName}</div>
                                    {team.avgPlace != null && <div className="cavg">Среднее место: {Number(team.avgPlace).toFixed(1)}</div>}
                                </div>
                                <div className="codds">
                                    <span className="bt-cchip"><span className="ck">1м:</span> {Number(team.oddsWin || 0).toFixed(2)}</span>
                                    <span className="bt-cchip"><span className="ck">Топ2:</span> {Number(team.oddsTop2 || 0).toFixed(2)}</span>
                                    <span className="bt-cchip"><span className="ck">Топ3:</span> {Number(team.oddsTop3 || 0).toFixed(2)}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </BetAccordion>
            )}

            {bets.length > 0 && (
                <BetAccordion label={betsLabel(bets, finished)}>
                    <div className="bt-bets">
                        {bets.map(bet => <BetRow key={bet.id} bet={bet} finished={finished} />)}
                    </div>
                </BetAccordion>
            )}

            {finished && sortedResults.length > 0 && (
                <>
                    <div className="bt-grouplabel mt">Результаты</div>
                    <div className="bt-resultlist">
                        {sortedResults.map(r => (
                            <div key={r.teamId} className="ri">
                                <span className={`rp ${placeClass(r.place)}`}>{r.place}</span>
                                <span className="bdot" style={{ background: colorOf(r.teamId) }} />
                                {r.teamName}
                            </div>
                        ))}
                    </div>
                </>
            )}

            {!finished && (
                <div className="bt-foot">
                    <button type="button" className="btn btn-danger" onClick={onDelete}>Удалить</button>
                    <button type="button" className="btn btn-ghost" onClick={onEdit}>Изменить</button>
                    <button type="button" className="btn btn-primary" onClick={onFinish}>Завершить</button>
                </div>
            )}
        </div>
    );
}

ActivityEventCard.propTypes = {
    event: PropTypes.object.isRequired,
    bets: PropTypes.array,
    colorOf: PropTypes.func.isRequired,
    finished: PropTypes.bool,
    onEdit: PropTypes.func,
    onFinish: PropTypes.func,
    onDelete: PropTypes.func
};

ActivityEventCard.defaultProps = { bets: [], finished: false, onEdit: undefined, onFinish: undefined, onDelete: undefined };
